/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').directive('designerStage', [
    '$rootScope',
    '$timeout',
    'DesignerStage',

    function ($rootScope, $timeout, DesignerStage) {
      return {
        templateNamespace: 'svg',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-stage.html'),
        replace: true,
        scope: {
          designer: '=',
        },
        link(scope, element, attrs) {
          $timeout(function () {
            scope.designer.stage.setElement(element);
          });
        },
      };
    },
  ]);
})(window.angular);
